import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";

export const getHasReferralsR2M = (): boolean | undefined => {
  return getGlobalProperty("hasReferralsR2M");
};
